import { Strong } from 'evergreen-ui';
import React, { memo } from 'react';

type Props = {
    satisfied?: boolean,
    className?: string
};

export const SlaBadge = memo(function SlaBadge({ satisfied = false, className = '' }: Props) {
    const text = satisfied ? 'Meets SLA' : 'Does not meet SLA';
    const bgColor = satisfied ? '#00AB93' : '#F02A2F';
    return (
        <Strong
            className={ `p-2 ${ className }`.trim() }
            backgroundColor={ bgColor }
            size={ 400 }
            font="inherit"
            style={ {
                color: '#FFFFFF'
            } }
        >
            { text }
        </Strong>
    );
});
